import { migrateQueue } from '@/API/repositories/queue';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef, useState } from 'react';

const useQueueMigrate = () => {
	const { options } = useCommonDataContext();
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { queuesOptions } = options;

	const [queueFrom, setQueueFrom] = useState();
	const [queueTo, setQueueTo] = useState();
	const [statuses, setStatuses] = useState([]);
	const dateFromRef = useRef(null);
	const maxCallAttemptsRef = useRef(null);

	const handleConfirm = async () => {
		const isValid = validateForm();
		if (!isValid) {
			return addMessage('All fields must be selected');
		}
		if (queueFrom.value === queueTo.value) {
			return addMessage("Queue 'from' and 'to' cannot be the same");
		}

		const payload = {
			queueIdFrom: queueFrom.value._id,
			queueIdTo: queueTo.value._id,
			dateFrom: dateFromRef.current?.value,
			orderStatuses: statuses.map((status) => status.value),
			maxCallAttempts: parseInt(maxCallAttemptsRef.current?.value),
		};

		const response = await makeRequest(migrateQueue.bind(null, payload));
		if (response.data) {
			return addMessage(`Migrated ${response.data.migrated} orders`, 'success');
		}

		addMessage(`Something went wrong.`, 'error');
	};

	const validateForm = () => {
		const maxCallAttempts = parseInt(maxCallAttemptsRef.current?.value);

		if (
			!queueFrom ||
			!queueTo ||
			!dateFromRef.current?.value ||
			statuses.length === 0 ||
			Number.isNaN(maxCallAttempts) ||
			maxCallAttempts < 0
		) {
			return false;
		}

		return true;
	};

	const isLoading = hasUnfilledRequest(migrateQueue);

	return {
		isLoading,
		queuesOptions,
		setQueueFrom,
		queueFrom,
		setQueueTo,
		queueTo,
		dateFromRef,
		handleConfirm,
		statuses,
		setStatuses,
		maxCallAttemptsRef,
	};
};

export default useQueueMigrate;
